import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setVoxAuthDialogVisible } from '../../features/dialogControl/dialogControlSlice';
import { getServerEndpoint } from '../../utils/utils';
import { 
    IconButton,
    Box,
    Button
} from "@mui/material";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import './vox-auth-dialog.css';
import { CustomTextField } from '../form-elements/form-elements'; 
import { useTheme } from '@mui/material/styles';


const VoxAuthDialog = () => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const serverEndpoint = getServerEndpoint(); // TODO : get rid of this nonsense
    const theme = useTheme();
    const dispatch = useDispatch();
    const location = useLocation();

    let serverUrl;
    if ( location.pathname === '/voice') {
        serverUrl = 'voxAuth';
    } else if (location.pathname === '/tracks' || location.pathname === '/artists') {
        serverUrl = 'auth';
    }

    const handleCancelClick = (event) => {
        event.stopPropagation();
        if (event.target.id !== 'dialog-container') dispatch(setVoxAuthDialogVisible(false));
    }


    const handleSubmit = async (e) => {
			e.preventDefault();
			setError('');
			const response = await fetch(`${serverEndpoint}/${serverUrl}`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ password }),
			});
			const data = await response.json();
			if (data.success) {
				if (serverUrl === 'voxAuth') {
                    localStorage.setItem('mb-vox-auth', 'true'); 
                } else if (serverUrl === 'auth') {
                    localStorage.setItem('mb-auth', 'true'); 
                }
				dispatch(setVoxAuthDialogVisible(false));
				window.location.reload();
			} else {
				setError('Invalid password');
			}
		};
        

    return (
        <div className='screen'>
            <div id='dialog-container' className='vox-auth-dialog-container'>
                <div className='vox-auth-dialog-header'>Login to Continue</div>
                <Box 
                    component="form"
                    onSubmit={handleSubmit}
                    autoComplete='off'
                    sx={{ 
                        display:'flex', 
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        width: '427px',
                    }}
                >
                    <Box>
                        <CustomTextField
                            sx={{
                                width: '300px'
                            }}
                            size="small"
							type="password"
                            label="PASSWORD"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            variant="outlined"
                            fullWidth
                            autoComplete="off"
                        />
                    </Box>

                    
                    {error && <Box sx={{ color: 'red', fontSize: '14px', marginBottom: '10px' }}>{error}</Box>}
                    
                    <Button 
                        sx={{
                            width:'86px',
                            height: '32px',
                            borderRadius: '4px',
                            marginBottom: '20px'
                        }}
                        type="submit" 
                        variant="contained" 
                        color="primary" 
                        fullWidth
                    >
                        Submit
                    </Button>
                </Box>

                <div className='close-button'>
                    <IconButton
                        onClick={(event) => handleCancelClick(event)}
                    >
                        <CancelOutlinedIcon 
                            sx= {{
                                color:theme.palette.color
                            }}
                        />
                    </IconButton>
                </div>
            </div>
        </div>
    );
}

export default VoxAuthDialog;